import { Modal, Spin } from 'antd';
import { FC, useState, useEffect } from 'react';
import { fetchAuthenticatedForBlob } from '../../../utils/api';

const BASE_URL = import.meta.env.VITE_CONFIG_API_URL;

interface PdfViewerModalProps {
  open: boolean;
  onClose: () => void;
  pdfName?: string;
  pdfId?: number;
  title: string;
}

export const PdfViewerModal: FC<PdfViewerModalProps> = ({ open, onClose, pdfName, pdfId, title }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open && !pdfUrl) {
      loadPdf();
    }
  }, [open]);

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl.split('#')[0]);
      }
    };
  }, [pdfUrl]);

  const loadPdf = async () => {
    setIsLoading(true);
    try {
      const url = pdfId ? `${BASE_URL}/handleiding/${pdfId}/view` : `${BASE_URL}/handleiding/${pdfName}`;
      const blob = await fetchAuthenticatedForBlob<Blob>(url);
      const blobUrl = URL.createObjectURL(blob);
      const viewerUrl = `${blobUrl}#toolbar=0&navpanes=0`;
      setPdfUrl(viewerUrl);
    } catch (error) {
      console.error('Error fetching PDF:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl.split('#')[0]);
      setPdfUrl(null);
    }
    onClose();
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      );
    }
    if (pdfUrl) {
      return <iframe src={pdfUrl} style={{ width: '100%', height: '80vh', border: 'none' }} title={title} />;
    }
    return null;
  };

  return (
    <Modal title={title} open={open} onCancel={handleClose} footer={null} width="80%" style={{ top: 20 }}>
      {renderContent()}
    </Modal>
  );
};
